// libraries.
import { ButtonGoogle } from '@domains/user';
import { Container } from 'react-bootstrap';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

// components
import { VersionTag } from './components';

// styles.
import { IconHabiPricing } from '@assets/icons';
import { ImageHero } from '@assets/images';
import { WrapperLogin } from './styles';

export const LoginPage = () => {
  const navigate = useNavigate();

  const authKey = process.env.ENV_GOOGLE_AUTH;

  const loginOnSuccess = (roles?: string[]) => {
    const roleRoutes: Record<string, string> = {
      'comercial': '/orchestrator-pricing-committee/list-opc',
      'idm-legal': '/orchestrator-pricing-committee/max-price-opc',
    };

    const route = roles?.find(role => roleRoutes[role]);
    navigate(route ? roleRoutes[route] : '/home');
  };

  return (
    <Container fluid className="p-0">
      <div className="d-flex">
        <div className="p-0">
          <ImageHero style={{ height: '100vh' }} />
        </div>
        <div className="d-flex align-items-center justify-content-center w-100 mb-5">
          <WrapperLogin className="mb-5">
            <div className="d-flex justify-content-center mb-5">
              <IconHabiPricing />
            </div>
            <div className="d-flex flex-column align-items-center gap-3 mb-5">
              <div className="title">Inteligencia de Mercados</div>
              <div>
                <div className="d-flex gap-2 title">
                  <div>Polynator</div>/<div>Trámites</div>
                </div>
              </div>
              <div className="google">
                Inicia sesión con tu <br /> cuenta de Google
              </div>
              {authKey ? (
                <GoogleOAuthProvider clientId={authKey}>
                  <ButtonGoogle onSuccess={loginOnSuccess} />
                </GoogleOAuthProvider>
              ) : (
                <div className="text-danger">
                  No se ha encontrado la clave de autenticación
                </div>
              )}
            </div>
          </WrapperLogin>
        </div>
      </div>
      <VersionTag />
    </Container>
  );
};
